<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="iid"
        label="业务号"
        error
        placeholder="请输入业务号"
        required
        style="min-height:150px;"
      />
    </van-cell-group>
    <van-button type="primary" size="large" @click="submitOnliePay">
      立即查询
    </van-button>
  </div>
</template>
<script type="text/javascript">
import { GetWaitPaymentOfflineOrder, startOnliePay } from '@/api/onlinePay'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
export default {
  components: {},
  data() {
    return {
      iid: '',
      webUserInfoId: '',
      initiateQrCodePayParams: {
        BusinessNo: '',
        PayerName: '',
        PayerTel: '',
        PayerCertificate: '',
        CreditCode: '',
        Device: '2',
        IsMicroCompany: false
      },
    }
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  mounted() {
    this.webUserInfoId = this.webUserInfo.id
  },
  methods: {
    submitOnliePay() {
      const webUserId = this.webUserInfoId // 用户id
      if (!webUserId) {
        Toast.fail('请先进行实名认证')
        return
      }
      if (!this.iid) {
        Toast.fail('内容不能为空')
        return
      }
      GetWaitPaymentOfflineOrder({
        businessNo: this.iid
      }).then(response => {
        if(response.data.StatusCode == 200){
          if(response.data.Data != null){
            this.initiateQrCodePayParams.BusinessNo = this.iid
            this.initiateQrCodePayParams.PayerName = this.webUserInfo.realName
            this.initiateQrCodePayParams.PayerTel = this.webUserInfo.mobilePhone
            this.initiateQrCodePayParams.PayerCertificate = this.webUserInfo.idNumber
            console.info(this.initiateQrCodePayParams)
            startOnliePay(this.initiateQrCodePayParams)
            .then(response => {
              console.info(response.data)
              if(response.data.StatusCode == 300){
                Toast.fail('发起在线缴税失败！')
              } else {

                if(response.data.Data.Code == "000"){
                Toast.success('提交成功')
                 // 跳转页面  
                 this.$router.push({
                      path: '/onlinePay/pay',
                      query: {requrl: response.data.Data.Requrl}
                  })
                // setTimeout(() => {
                //   Toast.success('提交成功')
                //     // 跳转页面
                //     this.$router.push({
                //       path: '/onlinePay/pay',
                //       query: {requrl: this.iid}
                //   })
                // }, 1500)
              } else{
                Toast.fail('发起在线缴税失败！')
              }
              }
          })
          }else{
            Toast.fail('根据业务号查询缴费信息为空，请输入正确缴费信息！')
          }
        }else{
          Toast.fail('信息查询失败！')
        }
      })


      // 跳转页面
      // this.$router.push({
      //   path: '/onlinePay/pay'
      // })
      // startOnliePay(this.initiateQrCodePayParams)
      //   .then(() => {
      //   Toast.success('提交成功')
      //   setTimeout(() => {
      //     // 跳转页面
      //     this.$router.push({
      //       path: '/onlinePay/pay'
      //     })
      //   }, 1500)
      // })
    }
  }
}

</script>
<style lang="scss" scoped>
  .consultation-add-container {
    background-color: #eee;
  }
</style>
